import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import { formatAmount, parseAmount, formatDate } from '@Utils/formatters'
import { cloneDeep } from 'lodash'
import moment from 'moment'
// Import the action creators
import * as Actions from './actions'

export const getListInterviews = () => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { interviewsList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompID = auth.credentials.companyId
    updateSortModel.UserID = auth.credentials.userId

    ApiService.get(Path.LIST, updateSortModel)
        .then((response) => {
            if (response) {
                const { data } = response
                dispatch(Actions.updateInterviewsList({
                    data: data.items,
                    totalCount: data.count,
                }))
            }
            // return response.data
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })

}

// INTERVIEW LIST ACTIONS/ACTION OPERATIONS
export const applySearchFilters = (searchModel) => (dispatch) => {
    // Page will always be zero upon searching
    dispatch(Actions.changeFilterPage(0))

    // dispatch the search filters
    dispatch(Actions.applyFilters(searchModel))

    // get data from server and update results
    dispatch(getListInterviews())
}

export const resetSearchResults = () => (dispatch) => {
    // reset filter
    dispatch(Actions.resetResults())
    // Update the list
    dispatch(getListInterviews())
}

export const resetFilters = () => (dispatch, getState) => {
    dispatch(Actions.resetFilters())
    return new Promise((resolve, reject) => {
        const { interviewsList: { searchFilter } } = getState()
        resolve(searchFilter)
    })
}

export const changePage = (newPage) => (dispatch) => {
    // dispatch change filter page
    dispatch(Actions.changeFilterPage(newPage))
    // Update the list
    dispatch(getListInterviews())
}

export const changeRowsPerPage = (pageModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterRowsPerPage(pageModel))
    // Update list
    dispatch(getListInterviews())
}

export const changeSort = (sortModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterSort(sortModel))
    // Update list
    dispatch(getListInterviews())
}

export const getApplicantIDToken = ({CompanyId, ID}) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))

    return ApiService.get(Path.GET_APPLICANT_DETAIL, {
        CompanyId,
        ID
    }).then((response) => {
        if (response.status === 200) {
            const { data } = response;

            dispatch(Actions.setInterviewsAdd(data))
        } 

        return response.data;
    })
    .catch((error) => {
        console.error(error)
    }).finally(() => {
        dispatch(Actions.hasDetailLoaded(true));
    })
}


// INTERVIEW ADD ACTION OPERATIONS
export const createInterview = (data) => (dispatch, getState) => {
    const { interviewsAdd: { alert } } = getState()
    let nAlert = { ...alert }

    dispatch(Actions.showLoading(true))

    return ApiService.post(Path.ROOT, data)
        .then((response) => {
            if (response) {
                let title = 'Create Success'
                const { message } = response.data
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    title = 'Create Failed'
                    goBackToList = false
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                }
            }
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
            dispatch(Actions.updateAddAlertData(nAlert))
        })
}

export const getInterviewsLatestHistoryDetail = ({CompanyId, ID}) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    const { interviewsAdd: { alert } } = getState()
    let nAlert = { ...alert }

    return ApiService.get(Path.GET_INTERVIEWER_DETAIL, {
        CompanyId,
        ID
    }).then((response) => {
        if (response.status === 200) {
            const { data } = response;

            dispatch(Actions.setInterviewsAdd(data))
        } 

        if (response.status === 204){
            const title = 'Missing information';
            const message = 'Employee has no Email Address.'

            nAlert = {
                ...nAlert,
                title: title,
                show: true,
                content: response.data.message != null? response.data.message : message,
                goBackToListFlag: true,
            }

            dispatch(Actions.updateAddAlertData(nAlert));
        }

        return response.data;
    })
    .catch((error) => {
        console.error(error)
    }).finally(() => {
        dispatch(Actions.hasDetailLoaded(true));
    })
}

export const getApplicantLatestHistoryDetail = ({CompanyId, ID}) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    const { interviewsAdd: { alert } } = getState()
    let nAlert = { ...alert }

    return ApiService.get(Path.GET_APPLICANT_DETAIL, {
        CompanyId,
        ID
    }).then((response) => {
        if (response.status === 200) {
            const { data } = response;

            dispatch(Actions.setInterviewsAdd(data))
        } 

        if (response.status === 204){
            const title = 'Missing information';
            const message = 'Employee has no Email Address.'

            nAlert = {
                ...nAlert,
                title: title,
                show: true,
                content: response.data.message != null? response.data.message : message,
                goBackToListFlag: true,
            }

            dispatch(Actions.updateAddAlertData(nAlert));
        }

        return response.data;
    })
    .catch((error) => {
        console.error(error)
    }).finally(() => {
        dispatch(Actions.hasDetailLoaded(true));
    })
}

export const getHolidayDates = (company) => (dispatch) => {
    dispatch(Actions.showLoading(true));
    return ApiService.get(Path.GET_HOLIDAY_DATES, { company })
        .then((response) => {
            let listData = response ? response.data.map(date => moment(date).format("YYYY-MM-DD")) : [];
            dispatch(Actions.setHolidayDates({holidayDates: listData}));
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false));
        });
};


// INTERVIEW DETAIL/UPDATE ACTION OPERATIONS
export const getInterviewsById = (id, mode) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    return ApiService.get(Path.ROOT + '/' + id)
         .then((response) => {
            if (response.status === 200) {
                const { data } = response
                const converteddata = convertToViewModel(data)
                dispatch(Actions.setInterviewsDetail(converteddata, mode))
            } else {
                console.log('Failed to load data')
                console.log(data)
            }
            return response;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const getInterviewsUpdatedHistoryDetail = ({CompanyId, ID}) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))

    return ApiService.get(Path.GET_INTERVIEWER_DETAIL, {
        CompanyId,
        ID
    }).then((response) => {
        if (response.status === 200) {
            const { data } = response;

            dispatch(Actions.setInterviewsAdd(data))
        } 

        return response.data;
    })
    .catch((error) => {
        console.error(error)
    }).finally(() => {
        dispatch(Actions.hasDetailLoaded(true));
    })
}


export const getApplicantUpdatedHistoryDetail = ({CompanyId, ID}) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))

    return ApiService.get(Path.GET_APPLICANT_DETAIL, {
        CompanyId,
        ID
    }).then((response) => {
        if (response.status === 200) {
            const { data } = response;

            dispatch(Actions.setInterviewsAdd(data))
        } 

        return response.data;
    })
    .catch((error) => {
        console.error(error)
    }).finally(() => {
        dispatch(Actions.hasDetailLoaded(true));
    })
}

export const getFilteredUpdateApplicant = (model) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))

    return ApiService.get(Path.FILTERED_UPDATED_APPLICANT, {companyId: model.companyId , id: model.id})
        .then((response) => {
        if (response.status === 200) {
            const { data } = response;

            dispatch(Actions.setInterviewsAdd(data))
        } 

        return response;
    })
    .catch((error) => {
        console.error(error)
    }).finally(() => {
        dispatch(Actions.hasDetailLoaded(true));
    })
}

export const getPositionLevel = (company, id) => (dispatch) => {
    dispatch(Actions.showLoading(true))
    return ApiService.get(Path.POSITION_LEVEL, { company, id })
        .then((response) => {
            let listData = [];
            if (response) {
                const { data } = response;
                listData = data.map(((item) => ({ name: item.name, value: item.value })));
                return listData
            } else {
                listData = data;
            };
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
        });
}

export const updateInterviews = (detailData, ID) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    let updateModel = dispatch(convertToUpdateModel(detailData));

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.put(Path.ROOT + '/' + ID, updateModel)
        .then((response) => {
            if (response) {
                let title = 'Update Success'
                const { message } = response.data
                let goBackToList = true
                if (response.data.returnCode <= 0) {
                    title = 'Update Failed'
                    goBackToList = false
                }

                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message != null ? message : 'Interviews successfully updated.',
                    confirmLabel: 'Ok',
                    goBackToListFlag: goBackToList,
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}   

export const deleteInterview = (data) => (dispatch) => {
    dispatch(Actions.isLoading(true))

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update Success',
            content: 'Interview successfully deleted.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.delete(Path.ROOT + '/' + data)
        .then((response) => {
            if (response) {
                let title = 'Delete Success'
                const { message } = response.data
                if (response.data.returnCode <= 0) {
                    title = 'Delete Failed'
                }
                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message,
                    confirmLabel: 'Ok',
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })

}

export const exportInterviewsReport = (filename) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { interviewsList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompID = auth.credentials.companyId

    return ApiService.export(Path.EXPORT, filename, updateSortModel)
        .then((response) => {
            return response
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const convertToUpdateModel = (data) => (dispatch, getState) => {
    const { auth } = getState()
    let userId = auth.credentials.userId
    return {
        UserID: userId,
        CompanyId: data.companyId,
        ApplicantID: data.applicantID,
        ApplicantName: data.applicantName,
        ApplicantEmail: data.applicantEmail,
        Interviewer: data.interviewer,
        InterviewerEmail: data.interviewerEmail,
        PositionApplied: data.positionApplied,
        ApplicantStatus: data.applicantStatus,
        InterviewSchedule: moment(data.interviewSchedule).format('YYYY-MM-DDTHH:mm:ss'),
        InterviewMode: data.interviewMode,
        AddressOrLink: data.addressOrLink,
        Remarks: data.remarks,
        PositionLevel: data.positionLevel,
        PositionAccepted: data.positionAccepted,
        RecommendedSalary: data.recommendedSalary,
        InterviewResult: data.interviewResult,
    }
}
export const convertToViewModel = (data) => {
    return {
        ...data,
        interviewSchedule: moment(data.interviewSchedule).format('MM/DD/YYYY HH:mm'),
        addressOrLink: data.addressOrLink,
        recommendedSalary: parseAmount(data.recommendedSalary),
    }
}

export const geteducationlevelName = (isUpdate = false) => async (dispatch, getState) => {
    if (isUpdate) {
        dispatch(Actions.hasDetailLoaded(false));
    } else {
        dispatch(Actions.showLoading(true));
    }
    let data;

     try {
            const response = await ApiService.get(Path.GET_INTERVIEW_MODE);
            if (response) {
                data = response.data;
            }
        } catch (error) {
            console.error(error);
        } finally {
            if (isUpdate) {
                dispatch(Actions.hasDetailLoaded(true));
            } else {
                dispatch(Actions.showLoading(false));
            }
        }
    
        return data;
}